import React, { useContext, useEffect } from 'react';
import { withRouter } from 'react-router-dom';
import _, { get } from 'lodash';
import { connect } from 'react-redux';
import withForm from 'modules/common/hoc/withForm';
import Select from 'react-select';
import Modal from 'modules/common/components/Modal';
import { Acl } from 'modules/common/components/Acl';
import { getJson } from 'session';
import PropTypes from 'prop-types';
import NumberFormat from 'react-number-format';
import Alert from 'react-s-alert';
import { ModalContext } from 'App';
import { numberFormat } from 'helper';
import { ucwords } from '../helper';
import * as actions from '../actions';
import * as c from '../constant';

function UpdateModal({
  businessInformation,
  businessActivity,
  originalGrossAmount,
  updateList,
  formData,
  setFormData,
  getBusinessNaturesList,
  businessNatures,
  getBusinessLinesList,
  businessLines,
  getNecessaryFieldsList,
  isBusinessLineIdLoading,
  necessaryFields,
  updateBusinessActivityGrossAmount,
  getItem,
  checkAssessor,
  isStartAssessment,
  reassessmentActivities,
  setActivities,
}) {
  const setModal = useContext(ModalContext);
  const businessId = _.get(businessInformation, 'id');
  const businessActivityId = _.get(businessActivity, 'id');
  const permissions = getJson('permissions');

  const isQuarterly =
    get(businessInformation, 'attributes.transaction_type') === 'QUARTERLY';
  useEffect(() => {
    getBusinessNaturesList();
    getBusinessLinesList();
  }, []);

  const handleOnSubmit = (e) => {
    e.preventDefault();

    const args = {
      gross_amount: _.get(formData, 'gross_amount'),
      capital_amount: _.get(formData, 'capital_amount'),
      override_amount: _.get(formData, 'override_amount'),
    };
    if (isQuarterly) {
      if (
        (_.get(formData, 'override_amount') === 0 ||
          !_.get(formData, 'override_amount')) &&
        +originalGrossAmount > _.get(formData, 'gross_amount')
      ) {
        Alert.error(
          `The gross amount must be greater than or equal ${originalGrossAmount}.`
        );
        return;
      }
      setActivities(
        reassessmentActivities.map((item) => {
          if (item.id === updateList.id)
            return {
              ...item,
              attributes: {
                ...item.attributes,
                gross_amount: _.get(formData, 'gross_amount'),
                gross_amount_human: numberFormat(
                  _.get(formData, 'gross_amount')
                ),
                override_amount: _.get(formData, 'override_amount'),
              },
            };
          return item;
        })
      );
      setModal({ isOpen: false });
      Alert.success('Updated Business Activity!');
      return;
    }
    updateBusinessActivityGrossAmount(
      businessId,
      businessActivityId,
      args,
      () => {
        setModal({ isOpen: false });
        getItem(businessId);
      }
    );
  };

  const closeModal = (e) => {
    e.preventDefault();
    setModal({ isOpen: false });
  };

  useEffect(() => {
    setFormData({
      ...formData,
      business_line_id: +_.get(updateList, 'business_line_id'),
      business_nature_id: +_.get(updateList, 'business_nature_id'),
      capital_amount: _.get(updateList, 'capital_amount'),
      gross_amount: _.get(updateList, 'gross_amount'),
      override_amount: _.get(updateList, 'override_amount'),
    });
  }, []);

  // select nature
  const handleNatureDropDownChange = (key) => (e) => {
    setFormData({
      ...formData,
      [key]: e ? e.value : '',
    });

    getBusinessLinesList({ business_nature_id: e.value });
  };

  const selectBusinessNaturesOption = businessNatures.map((x) => ({
    label: _.get(x, 'attributes.name'),
    value: x.id,
    id: x.id,
  }));

  const findBusinessNatureValue =
    selectBusinessNaturesOption.find(
      (item) => +_.get(formData, 'business_nature_id') === +item.id
    ) || '';

  // select line
  const handleLineDropDownChange = (key) => (e) => {
    setFormData({
      ...formData,
      [key]: e ? e.value : '',
    });

    getNecessaryFieldsList({ business_line_id: e.value });
  };

  const selectBusinessLinesOption = businessLines.map((x) => ({
    label: _.get(x, 'attributes.name'),
    value: x.id,
    id: x.id,
  }));

  const findBusinessLineValue =
    selectBusinessLinesOption.find(
      (item) =>
        _.get(formData, 'business_line_id')?.toString() === item.id?.toString()
    ) ||
    (!_.isEmpty(findBusinessNatureValue)
      ? {
          label: _.get(updateList, 'name'),
          value: _.get(updateList, 'business_line_id'),
          id: _.get(updateList, 'business_line_id'),
        }
      : '');

  // select necessary field
  const handleOfficeTypeDropDownChange = (key) => (e) => {
    setFormData({
      ...formData,
      [key]: e ? e.value : '',
    });
  };

  const selectOptions = (list) => {
    const newList = [];

    list.map((dataMultiplier) => {
      return newList.push({
        label: ucwords(_.get(dataMultiplier, 'multiplier'))
          .replace(/_/g, ' ')
          .replace(/^(.)|\s+(.)/g, (x) => x.toUpperCase()),
        value: dataMultiplier.multiplier,
      });
    });
    return newList;
  };

  const handleOnChange = (key) => (e) => {
    setFormData({
      ...formData,
      [key]: e.target.value,
    });
  };

  const onCheck = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.checked === true ? 1 : 0,
    });
  };

  return (
    <Modal.Body>
      <form onSubmit={handleOnSubmit}>
        <div className="row">
          <div className="col-12 form-group">
            <label className="form-label">Business Nature:</label>
            <Select
              isDisabled
              options={selectBusinessNaturesOption}
              placeholder="Select Business Nature"
              value={findBusinessNatureValue}
              onChange={handleNatureDropDownChange('business_nature_id')}
            />
          </div>
          <div className="col-12 form-group">
            <label className="form-label">Business Line:</label>
            <Select
              isDisabled
              options={selectBusinessLinesOption}
              placeholder="Select Business Line"
              isLoading={isBusinessLineIdLoading}
              value={findBusinessLineValue}
              onChange={handleLineDropDownChange('business_line_id')}
            />
          </div>
          <div className="col-12 form-group">
            <label className="form-label">Capital Amount:</label>
            <NumberFormat
              name="capital_amount"
              id="capital_amount"
              placeholder="0"
              className="form-control"
              onValueChange={(values) => {
                const { floatValue } = values;
                setFormData({
                  ...formData,
                  capital_amount: floatValue,
                });
              }}
              /* eslint-disable */
              isNumericString={true}
              thousandSeparator={true}
              allowNegative={true}
              allowLeadingZeros={true}
              displayType="input"
              prefix=""
              value={`${_.get(formData, 'capital_amount', '')}` || ''}
              disabled={
                _.get(businessInformation, 'attributes.transaction_type') ===
                  'RENEWAL' || isQuarterly
              }
            />
          </div>
          <div className="col-12 form-group">
            <label className="form-label">Gross Amount:</label>
            <NumberFormat
              name="gross_amount"
              id="gross_amount"
              placeholder="0"
              className="form-control"
              onValueChange={(values) => {
                const { floatValue } = values;
                setFormData({
                  ...formData,
                  gross_amount: floatValue,
                });
              }}
              /* eslint-disable */
              isNumericString={true}
              thousandSeparator={true}
              allowNegative={true}
              allowLeadingZeros={true}
              displayType="input"
              prefix=""
              value={`${_.get(formData, 'gross_amount', '')}` || ''}
              disabled={
                _.get(businessInformation, 'attributes.transaction_type') ===
                'NEW'
              }
            />
          </div>
          {['RENEWAL'].indexOf(
            get(businessInformation, 'attributes.transaction_type')
          ) > -1 &&
            get(businessInformation, 'attributes.transaction_status') ===
              'FOR CHECKING' &&
            get(
              businessInformation,
              'included.bplsApplication.attributes.status'
            ) === 'FOR LICENSE ASSESSMENT' &&
            isStartAssessment === 1 &&
            checkAssessor() &&
            Acl(permissions, ['OVERRIDE BPLS AMOUNT']) &&
            Acl(permissions, ['E2E BPLS OVERRIDE AMOUNT BEFORE SOA']) && (
              <div className="col-12 form-group">
                <label htmlFor="last_name" className="form-label">
                  Override Minimum Amount &nbsp;
                </label>
                <input
                  name="override_amount"
                  type="checkbox"
                  checked={_.get(formData, 'override_amount')}
                  onChange={onCheck}
                />
              </div>
            )}
          {['RENEWAL'].indexOf(
            get(businessInformation, 'attributes.transaction_type')
          ) > -1 &&
            ['PENDING', 'FOR LICENSE ASSESSMENT'].indexOf(
              get(businessInformation, 'attributes.transaction_status')
            ) > -1 &&
            get(
              businessInformation,
              'included.bplsApplication.attributes.status'
            ) === 'COMPUTED' &&
            checkAssessor() &&
            Acl(permissions, ['OVERRIDE BPLS AMOUNT']) &&
            Acl(permissions, ['E2E BPLS OVERRIDE AMOUNT AFTER SOA']) && (
              <div className="col-12 form-group">
                <label htmlFor="last_name" className="form-label">
                  Override Minimum Amount &nbsp;
                </label>
                <input
                  name="override_amount"
                  type="checkbox"
                  checked={_.get(formData, 'override_amount')}
                  onChange={onCheck}
                />
              </div>
            )}
          {['QUARTERLY'].indexOf(
            get(businessInformation, 'attributes.transaction_type')
          ) > -1 &&
            ['REASSESSING'].indexOf(
              get(businessInformation, 'attributes.transaction_status')
            ) > -1 &&
            checkAssessor() &&
            Acl(permissions, ['E2E BPLS QUARTERLY OVERRIDE AMOUNT']) && (
              <div className="col-12 form-group">
                <label htmlFor="last_name" className="form-label">
                  Override Minimum Amount &nbsp;
                </label>
                <input
                  name="override_amount"
                  type="checkbox"
                  checked={_.get(formData, 'override_amount')}
                  onChange={onCheck}
                />
              </div>
            )}
          <div className="col-12 form-group">
            {necessaryFields.map((item) => {
              return (
                <div>
                  <div>
                    {_.get(item, 'options') ? (
                      <div>
                        <label className="form-label">
                          {ucwords(
                            _.get(item, 'multiplier').replace(/_/g, ' ')
                          )}{' '}
                        </label>
                        <Select
                          isDisabled
                          onChange={handleOfficeTypeDropDownChange(
                            _.get(item, 'multiplier')
                          )}
                          options={selectOptions(_.get(item, 'options'))}
                          value={
                            selectOptions(_.get(item, 'options')).find(
                              (x) =>
                                _.get(formData, _.get(item, 'multiplier')) ===
                                _.get(x, 'value')
                            ) || ''
                          }
                        />
                      </div>
                    ) : (
                      ''
                    )}
                  </div>
                  <div className="form-group">
                    {!_.get(item, 'options') ? (
                      <div>
                        <label className="form-label">
                          {ucwords(
                            _.get(item, 'multiplier').replace(/_/g, ' ')
                          )}{' '}
                        </label>
                        <input
                          disabled
                          className="form-control"
                          name={_.get(item, 'label')}
                          id={_.get(item, 'label')}
                          onChange={handleOnChange(_.get(item, 'multiplier'))}
                          value={_.get(formData, _.get(item, 'multiplier'))}
                          required
                        />
                      </div>
                    ) : (
                      ''
                    )}
                  </div>
                </div>
              );
            })}
          </div>
        </div>
        <div className="d-flex justify-content-center">
          <button
            type="submit"
            className="mt-3 btn btn-primary cms-bg-color-primary cms-outline-primary  mr-3   "
          >
            <span className="font-weight-bold">Submit</span>
          </button>
          <button
            type="button"
            onClick={closeModal}
            className="mt-3 btn btn-dark "
          >
            <span className="font-weight-bold">Cancel</span>
          </button>
        </div>
      </form>
    </Modal.Body>
  );
}

UpdateModal.defaultProps = {
  isBusinessLineIdLoading: false,
  isStartAssessment: 0,
  reassessmentActivities: {},
  originalGrossAmount: 0,
};

UpdateModal.propTypes = {
  businessInformation: PropTypes.instanceOf(Object).isRequired,
  businessActivity: PropTypes.instanceOf(Object).isRequired,
  updateList: PropTypes.instanceOf(Object).isRequired,
  formData: PropTypes.instanceOf(Object).isRequired,
  setFormData: PropTypes.instanceOf(Object).isRequired,
  getBusinessNaturesList: PropTypes.instanceOf(Function).isRequired,
  businessNatures: PropTypes.instanceOf(Array).isRequired,
  getBusinessLinesList: PropTypes.instanceOf(Function).isRequired,
  businessLines: PropTypes.instanceOf(Array).isRequired,
  isBusinessLineIdLoading: PropTypes.bool,
  getNecessaryFieldsList: PropTypes.instanceOf(Function).isRequired,
  necessaryFields: PropTypes.instanceOf(Array).isRequired,
  updateBusinessActivityGrossAmount: PropTypes.instanceOf(Function).isRequired,
  getItem: PropTypes.instanceOf(Function).isRequired,
  checkAssessor: PropTypes.instanceOf(Function).isRequired,
  setActivities: PropTypes.instanceOf(Function).isRequired,
  reassessmentActivities: PropTypes.instanceOf(Object),
  isStartAssessment: PropTypes.number,
  originalGrossAmount: PropTypes.string,
};

const mapStateToProps = ({ api }) => ({
  businessNatures: _.get(api, `${c.GET_BUSINESS_NATURES_LIST}.list`) || [],
  businessLines: _.get(api, `${c.GET_BUSINESS_LINES_LIST}.list`) || [],
  isBusinessLineIdLoading:
    _.get(api, 'loading', []).indexOf(c.GET_BUSINESS_LINES_LIST) > -1,
  necessaryFields: _.get(api, `${c.GET_NECESSARY_FIELD_LIST}.list`) || [],
});

const enhance = _.flowRight([
  withForm,
  withRouter,
  connect(mapStateToProps, {
    ...actions,
  }),
]);

export default enhance(UpdateModal);
